import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  FormHeader,
  ReachCard,
  SectionHeader,
  TopMenu,
} from "../../components";
import Footer from "../footer/index";
import { getLanguage } from "../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const lan = getLanguage();

const Index = (props) => {
  const [news, setNews] = React.useState("");

  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{news?.title?.[lan] || "News today"}</title>
        <meta
          name="description"
          content={
            news?.summary?.[lan]?.slice(0, 150) ||
            "Latest news updates from Hope of a New Era."
          }
        />
        <meta property="og:title" content={news?.title?.[lan]} />
        <meta
          property="og:description"
          content={news?.summary?.[lan]?.slice(0, 150)}
        />
        <meta property="og:image" content={news?.images?.[0]?.url} />
        <meta property="og:url" content={window.location.href} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: news?.title?.[lan],
            image: [news?.images?.[0]?.url],
            datePublished: news?.created_at,
            dateModified: news?.updated_at || news?.created_at,
            author: {
              "@type": "Organization",
              name: "Hope of a New Era",
            },
            publisher: {
              "@type": "Hope of a New Era",
              name: "Hope of a New Era",
              logo: {
                "@type": "ImageObject",
                url: "https://example.com/logo.png",
              },
            },
          })}
        </script>
      </Helmet>
      <>
        <div>
          <TopMenu
            data={{
              size: "lg",
              isLanguage: true,
              isLogo: false,
              isProfile: false,
            }}
            onClickPublish={() => {
              props.history.push("/admin");
            }}
          />
        </div>
        <div className={"container"}>
          <div className={"apw__tab"}>
            <div className={"apwt__hope"}>
              <img
                src={require("../../assets/img/logo_new.png")}
                alt={news?.title?.[lan]}
                //style={{ marginRight: "17px" }}
              />
              {/* <img
                src={require("../../assets/img/Frame 44.png")}
                alt={news?.title?.[lan]}
                className={"apwth__adv-logo"}
              /> */}
            </div>
            <div className={"apwt__action"}>
              <Button
                data={{
                  btnName: "SIGN IN",
                  buttonType: "black-border",
                  buttonSize: "sm x",
                  isLoading: false,
                }}
                onClick={() => {
                  props.history.push("/ads/sign-in");
                }}
              />
              <Button
                data={{
                  btnName: "START NOW",
                  buttonType: "primary",
                  buttonSize: "sm x",
                  isLoading: false,
                }}
                onClick={() => {
                  props.history.push("/ads/sign-up");
                }}
              />
            </div>
          </div>
        </div>

        <div className={"ads-platform-wrapper"}>
          {/* top-wrapper */}
          <div className={"apw__top-main-wrapper"}>
            <div className={"container"}>
              <div className={"apw__top"}>
                <div className={"apwt__left"}>
                  <FormHeader
                    data={{
                      size: "xl",
                      mainLayerStyles: "",
                      formHeader: "Reach Thousands of",
                    }}
                  />
                  <FormHeader
                    data={{
                      size: "xl",
                      mainLayerStyles: "",
                      formHeader: "Engaged",
                    }}
                  />
                  <FormHeader
                    data={{
                      size: "xl",
                      mainLayerStyles: "",
                      formHeader: "Readers Every Day",
                    }}
                  />
                  <div className={"apwtl__action"}>
                    <Button
                      data={{
                        btnName: "START NOW",
                        buttonType: "primary",
                        buttonSize: "sm",
                        isLoading: false,
                      }}
                      onClick={() => {
                        props.history.push("/ads/sign-up");
                      }}
                    />
                  </div>
                </div>
                <img src={require("../../assets/img/image 6.png")} />
              </div>
            </div>
          </div>

          <div className={"container"}>
            {/* reach-wrapper */}
            <div className={"apw__reach"}>
              <FormHeader
                data={{
                  size: "md x",
                  mainLayerStyles: "mb-4",
                  formHeader:
                    "Reach the right person, with the right message, at the right time",
                }}
              />
              <div className={"apwr__sectionheader"}>
                <SectionHeader
                  data={{
                    size: "md-md",
                    title:
                      "Powered by advanced AI and machine learning, the [NAME] platform helps you optimize your entire marketing strategy with insights from all of your campaigns, across every channel.",
                    mainLayerStyles: "",
                  }}
                />
              </div>
              <div className={"apwr__body"}>
                <ReachCard
                  data={{
                    isImgUrl: false,
                    header: "Maximize leads and conversions",
                    subheader:
                      "Get better quality leads and enhance conversions.",
                  }}
                />

                <ReachCard
                  data={{
                    isImgUrl: false,
                    header: "Increase online sales",
                    subheader:
                      "Show up where shoppers are and increase site traffic and sales.",
                  }}
                />

                <ReachCard
                  data={{
                    isImgUrl: false,
                    header: "Drive in-store foot traffic",
                    subheader:
                      "Bring people through your doors and increase offline sales.",
                  }}
                />

                <ReachCard
                  data={{
                    isImgUrl: false,
                    header: "Show your brand to more people",
                    subheader:
                      "Put your brand out there to increase reach and engagement.",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};

export default withRouter(Index);
